import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Router, RoutesRecognized} from '@angular/router';
import {MGiftVoucherPriceCategoryComponent} from '../../master-files/m-gift-voucher-price-category/m-gift-voucher-price-category.component';
import {TGiftVoucherTransferComponent} from '../../transactions/t-gift-voucher-transfer/t-gift-voucher-transfer.component';
import {MGiftVoucherComponent} from '../../master-files/m-gift-voucher/m-gift-voucher.component';
import {MBulkGiftVoucherCustomerService} from '../../master-files/m-gift-voucher-bulk-customer/service/m-gift-voucher-customer.service';
import {MGiftVoucherBulkCustomerComponent} from '../../master-files/m-gift-voucher-bulk-customer/m-gift-voucher-bulk-customer.component';
import {MStoreComponent} from '../../master-files/m-store/m-store.component';
import {MSupplierComponent} from '../../master-files/m-supplier/m-supplier.component';
import {TGrnComponent} from '../../transactions/t-grn/t-grn.component';
import {TStockTransferOutComponent} from '../../transactions/t-stock-transfer-out/t-stock-transfer-out.component';
import {TStockTransferInApproveComponent} from '../../transactions/t-stock-transfer-in-approve/t-stock-transfer-in-approve.component';
import {TransactionSummaryDashboardComponent} from '../../dashboard/transaction-summary-dashboard/transaction-summary-dashboard.component';

export enum NavigationMenuTypes {
  OVERVIEW,
  GIFT_VOUCHER_TRANSFER,
  GIFT_VOUCHER,
  GIFT_VOUCHER_PRICE_CATEGORY,
  GIFT_VOUCHER_BULK_CUSTOMER,
  STOTE,
  SUPPLIER,
  GRN,
  STOCK_TRANSFER_OUT,
  STOCK_TRANSFER_APPROVE,
  DTRANSACTIONSUMMARYDASHBOARD
}

export const NavigationMenus = [
  {
    title: 'OVER',
    description: ''
  },
  {
    title: 'GIFT VOUCHER TRANSFER',
    description: ''
  },
  {
    title: 'GRN',
    description: ''
  },
  {
    title: 'GIFT VOUCHER',
    description: ''
  },
  {
    title: 'GIFT VOUCHER PRICE CATEGORY',
    description: ''
  },
  {
    title: 'GIFT VOUCHER BULK CUSTOMER',
    description: ''
  },
  {
    title: 'STORE',
    description: ''
  },
  {
    title: 'SUPPLIER',
    description: ''
  },
  {
    title: 'STOCK TRANSFER OUT',
    description: ''
  },
  {
    title: 'STOCK TRANSFER APPROVE',
    description: ''
  }
  , {
    title: 'TRANSACTION SUMMARY DASHBOARD',
    description: ''
  },
];

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit {

  NavigationMenuTypes: typeof NavigationMenuTypes = NavigationMenuTypes;
  public activeMenu: NavigationMenuTypes;
  @Output() public changeMenu = new EventEmitter<NavigationMenuTypes>();

  constructor(private router: Router) {
  }

  ngOnInit() {
    // a little hack
    this.router.events.subscribe((event) => {
      if (event instanceof RoutesRecognized) {
        switch (event.state.root.firstChild.component) {
          case TGiftVoucherTransferComponent:
            this.setActiveMenu(NavigationMenuTypes.GIFT_VOUCHER_TRANSFER);
            break;
          case TGrnComponent:
            this.setActiveMenu(NavigationMenuTypes.GRN);
            break;
          case MGiftVoucherComponent:
            this.setActiveMenu(NavigationMenuTypes.GIFT_VOUCHER);
            break;
          case MGiftVoucherPriceCategoryComponent:
            this.setActiveMenu(NavigationMenuTypes.GIFT_VOUCHER_PRICE_CATEGORY);
            break;
          case MGiftVoucherBulkCustomerComponent:
            this.setActiveMenu(NavigationMenuTypes.GIFT_VOUCHER_BULK_CUSTOMER);
            break;
          case MStoreComponent:
            this.setActiveMenu(NavigationMenuTypes.STOTE);
            break;
          case MSupplierComponent:
            this.setActiveMenu(NavigationMenuTypes.SUPPLIER);
            break;
          case TStockTransferOutComponent:
            this.setActiveMenu(NavigationMenuTypes.STOCK_TRANSFER_OUT);
            break;
          case TStockTransferInApproveComponent:
            this.setActiveMenu(NavigationMenuTypes.STOCK_TRANSFER_APPROVE);
            break;
          case TransactionSummaryDashboardComponent:
            this.setActiveMenu(NavigationMenuTypes.DTRANSACTIONSUMMARYDASHBOARD);
            break;
          default:
            this.setActiveMenu(NavigationMenuTypes.OVERVIEW);
            break;
        }
      }
    });

  }

  setActiveMenu(activeMenu: NavigationMenuTypes): void {
    this.activeMenu = activeMenu;
    this.changeMenu.emit(this.activeMenu);
  }

  isMainFunctionsActive(): boolean {
    return this.activeMenu !== NavigationMenuTypes.OVERVIEW;
  }


}



// WEBPACK FOOTER //
// ./src/app/view/common/navigation/navigation.component.ts